import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class IFTAService extends BaseService {

	constructor() {	
		super();
	}
	
	async getIftaTaxRates(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/ifta-tax-rates' + params);		
		return data;		
	}
	
	async getIftaTaxRate(id) {
		var data = await this.makeGETRequest('/api/resource/ifta-tax-rates/' + id);		
		return data;		
	}
		
	async saveIftaRates(headerRate, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/ifta-tax-rates/' + headerRate.iftaTaxId, headerRate);
		} else {
			saved = await this.makePOSTRequest('/api/resource/ifta-tax-rates', headerRate);
		}
		return saved;		
	}	
	
	async deleteIftaRates(ids) {
		var data = await this.makeDELETERequest('/api/resource/ifta-tax-rates',  ids);		
		return data;		
	}	
	
	//details
	async getIftaTaxDetails(iftaTaxId) {
		var data = await this.makeGETRequest('/api/resource/ifta-tax-rates/' + iftaTaxId + '/details');		
		return data;		
	}

	exportIftaTaxDetails(iftaTaxId) {	
		this.downloadFile('/api/resource/ifta-tax-rates/' + iftaTaxId + '/details/export');		
	};	
	
	async saveIftaDetails(iftaTaxId, detail, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/ifta-tax-rates/' + iftaTaxId + '/details', detail);
		} else {
			saved = await this.makePOSTRequest('/api/resource/ifta-tax-rates/' + iftaTaxId + '/details', detail);
		}
		return saved;		
	}	
	
	async deleteIftaDetails(iftaTaxId, deleteModel) {
		var data = await this.makeDELETERequest('/api/resource/ifta-tax-rates/' + iftaTaxId + '/details', deleteModel);		
		return data;		
	}		
		
	
	//Interest Rate	
	async getIftaInterests(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/ifta-interests' + params);		
		return data;		
	}
	
	async getIftaInterest(id) {
		var data = await this.makeGETRequest('/api/resource/ifta-interests/' + id);		
		return data;		
	}
	
	exportIftaInterests(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/ifta-interests/export' + params);		
	};	
	
	async saveIftaInterest(interest, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/ifta-interests/' + interest.iftaTaxInterestId, interest);
		} else {
			saved = await this.makePOSTRequest('/api/resource/ifta-interests', interest);
		}
		return saved;		
	}	
	
	async deleteIftaInterests(iftaTaxInterestId) {
		var data = await this.makeDELETERequest('/api/resource/ifta-interests/' + iftaTaxInterestId);		
		return data;		
	}
		
}

